import angular from 'angular';

import dashboardByGroupComponent from './dashboardByGroup.component';
import dashboardByGroupComponentPart from './dashboardByGroupPart.component';
import './dashboardByGroup.component.scss';


export default angular.module('petroCloud.base.dashboardByGroup', [])
  .component(dashboardByGroupComponent.name, dashboardByGroupComponent)
  .component(dashboardByGroupComponentPart.name, dashboardByGroupComponentPart)
  .name;
